import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { ConfirmModal, Logo } from 'components/project/ClerkScreen';
import ZoomButton from '../../ClerkScreen/ZoomButton';
import {
  Container,
  Title,
  LeftSide,
  RightSide,
  LaunchPadButton,
  FlexRow,
} from './Styles';
import {
  TopBarButtonContainer,
  DisconnectButton,
} from '../ConnectDisconnect/Styles';
import { LaunchPad } from '../../../shared/LaunchPad/LaunchPad';

const TopBarContainer = ({
  title,
  connected,
  laneName,
  showLogout,
  showLogo,
  showLaunchPad,
}) => {
  const {
    BidStore: {
      auction: { zoomLevel },
    },
    UIStore: { handleLogout },
  } = useStores();

  const message = `Your connection will be terminated.${
    laneName
      ? ` Even though the ${laneName} lane is running, online users will not be impacted; however, if you wish to end the lane, then you must cancel, then click the 'End Lane' button on the main screen.`
      : ''
  }`;

  return (
    <Container zoomLevel={zoomLevel}>
      {connected && (
        <LeftSide>
          {(showLogout || showLaunchPad || showLogo) && (
            <TopBarButtonContainer>
              <FlexRow>
                {showLogo && (
                  <Logo
                    url={`${process.env.PUBLIC_URL}/assets/logo.png`}
                    alt="National Powersport Auctions"
                    width="150px"
                  />
                )}
                {showLogout && (
                  <ConfirmModal
                    title="Are you sure you want to logout?"
                    message={message}
                    confirmText="Logout"
                    onConfirm={handleLogout}
                    renderLink={(modal) => (
                      <DisconnectButton
                        data-testid="clerk-logout"
                        onClick={modal.open}
                      >
                        <i className="fa fa-plug fa-2" aria-hidden="true" />
                        Logout
                      </DisconnectButton>
                    )}
                  />
                )}
              </FlexRow>
            </TopBarButtonContainer>
          )}
        </LeftSide>
      )}
      <Title>{title}</Title>
      <RightSide>
        <ZoomButton />
      </RightSide>
    </Container>
  );
};

TopBarContainer.defaultProps = {
  connected: false,
  laneName: '',
  showLogo: false,
  showLaunchPad: false,
  title: '',
};

TopBarContainer.propTypes = {
  connected: PropTypes.bool,
  laneName: PropTypes.string,
  showLogo: PropTypes.bool,
  showLogout: PropTypes.bool.isRequired,
  title: PropTypes.string,
  showLaunchPad: PropTypes.bool,
};

export default observer(TopBarContainer);
